var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from "react";
import { Column } from "react-vcomponents";
import { BaseComponentPlus } from "react-vextensions";
import { PanelHeader } from "UI/Write/MapUI/Panel";
import { ModifyString } from "js-vextensions";
import { store } from "Store";
import { Observer } from "vwebapp-framework";
import { GetToolClassByName } from "../MapScene";
let ToolPanel = class ToolPanel extends BaseComponentPlus({}, {}) {
    render() {
        const { mapUI } = this.props;
        const selectedTool = store.main.write.selectedTool;
        const SelectedToolClass = GetToolClassByName(selectedTool);
        return (React.createElement(Column, null,
            React.createElement(PanelHeader, { text: `Tool${selectedTool ? ` (${ModifyString(selectedTool, m => [m.startLower_to_upper, m.lowerUpper_to_lowerSpaceLower]).slice(1)})` : ""}` }),
            React.createElement(Column, null, SelectedToolClass &&
                React.createElement(SelectedToolClass, { mapScene: mapUI.mapScene }))));
    }
};
ToolPanel = __decorate([
    Observer
], ToolPanel);
export { ToolPanel };
// next: add shape-drawer class (used by the add-object and draw-shape tools), which accepts min-line-length (and such) as parameters
